import type { QuoteStatus } from "@/types";
import { statusLabel, statusTone } from "@/lib/status";
import "./StatusPill.css";

/** Staff status pill covering all eight statuses (spec §6), including the
 *  `converted` status the design mockup omits. Tone comes from lib/status —
 *  expired maps to the danger palette (no --warning in components). */
export function StatusPill({ status }: { status: QuoteStatus }) {
  const tone = statusTone(status);
  return (
    <span className={`pill pill--${tone}`} data-status={status}>
      <span className="pill__dot" aria-hidden="true" />
      {statusLabel(status)}
    </span>
  );
}
